'use strict';

angular
  .module('webAgro1App')
  // eslint-disable-next-line max-params, max-lines-per-function
  .controller('UsuarioCtrl', function($scope, $rootScope, $q, $routeParams, $location, $window, Flash, filterFilter,
    UsuariosService, LoadingService, PropriedadesService, MessagesService, FuncoesService, PHONE_MASK, CPF_MASK) {
    $scope.PHONE_MASK = PHONE_MASK;
    $scope.CPF_MASK = CPF_MASK;

    const defaultUserParams = {
      utilizaMobile: true
    };

    const getPropriedadesUserSelected = function(propriedades) {
      ($scope.newUsuario.propriedades || []).forEach(function(propriedade) {
        const selectedPropriedade = filterFilter(propriedades, { id: propriedade.id }, true)[0];
        if (selectedPropriedade) {
          selectedPropriedade.selected = true;
        }
      });

      return propriedades;
    };

    const getFieldsServices = function() {
      const promises = [
        FuncoesService.listNoPaginated(),
        PropriedadesService.all()
      ];

      if ($routeParams.id) {
        promises.push(UsuariosService.getUsuario($routeParams.id));
      }

      $q.all(promises).then(function(data) {
        $scope.funcoes = data[0].data || [];
        $scope.newUsuario = data[2] || defaultUserParams;
        $scope.newUsuario.allPropriedades = getPropriedadesUserSelected(data[1].data);

        if ($routeParams.id && !$scope.newUsuario.id) {
          $scope.goToIndex();
        }

        $scope.readonlyCPF = $scope.newUsuario.id && $scope.newUsuario.cpf;
      }, function() {
        MessagesService.alert('Não foi possível carregar os dados.');
        $scope.goToIndex();
      })
        .finally(LoadingService.hideLoading);
    };

    $scope.readonlyCPF = false;

    const initialize = function() {
      LoadingService.showLoading();
      $rootScope.initialize.then(function() {
        if (!$rootScope.permissions.usuario.canManage) {
          $location.path('/');
          Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
          return;
        }

        getFieldsServices();
      }, $rootScope.errorRootInitialize);
    };

    const setSelectedPropriedades = function(checked) {
      ($scope.newUsuario.allPropriedades || []).forEach(function(propriedade) {
        propriedade.selected = checked;
      });
    };

    $scope.checkedAllPropriedades = function() {
      setSelectedPropriedades(true);
    };

    $scope.uncheckedAllPropriedades = function() {
      setSelectedPropriedades(false);
    };

    const scrollToTop = function() {
      $(window).animate({
        scrollTop: 0
      });
    };

    const errorHandler = function(error) {
      console.error(`Error ${error}`);
      let errorMsg = FALHA_AO_SALVAR_REGISTRO.msg;
      if (error.data) {
        if (error.data.base) {
          errorMsg = error.data.base;
        } else if (error.data.nome) {
          $scope.erroNomeDuplicado = true;
        } else if (error.data.cpf) {
          errorMsg += Object.keys(error.data).map((key) => `<br />${key.toUpperCase()} ${error.data[key]}.`);

          $scope.erroCPFLoginUnificado = error.data.cpf;
        }
      }
      scrollToTop();
      Flash.create(FALHA_AO_SALVAR_REGISTRO.type, errorMsg);
    };
    // TODO: rever complexity
    // eslint-disable-next-line complexity
    $scope.save = function(form) {
      if (form.$invalid) {
        return;
      }

      if ($scope.newUsuario.senha !== $scope.newUsuario.confirmaSenha) {
        MessagesService.alert('As senhas devem ser iguais!');
        return;
      }

      if ($scope.newUsuario.utilizaMobile && (!$scope.newUsuario.funcao || !$scope.newUsuario.funcao.id)) {
        MessagesService.alert('Selecione uma função!');
        return;
      }

      $scope.newUsuario.propriedades = filterFilter($scope.newUsuario.allPropriedades, { selected: true }, true) || [];

      if ($scope.newUsuario.propriedades.length === 0 && $scope.newUsuario.utilizaMobile) {
        MessagesService.alert('Selecione ao menos uma propriedade!');
        return;
      }

      $scope.erroNomeDuplicado = false;
      LoadingService.showLoading();
      const method = $scope.newUsuario.id ? UsuariosService.update : UsuariosService.save;
      method.call(UsuariosService, $scope.newUsuario).then(function() {
        $scope.goToIndex();
        Flash.create(REGISTRO_SALVO_COM_SUCESSO.type, REGISTRO_SALVO_COM_SUCESSO.msg);
      }, function(error) {
        errorHandler(error);
      })
        .finally(LoadingService.hideLoading);
    };

    $scope.goToIndex = function() {
      $location.path('/usuarios');
    };

    $scope.resetErrors = function() {
      $scope.erroCPFLoginUnificado = null;
    };

    initialize();

    $scope.colorOptions = {
      format: 'hex',
      swatch: true,
      swatchBootstrap: true,
      swatchOnly: true
    };
  });
